<div class="login-page">

  <div class="login-card">

    <!-- QR Tracker Illustration -->
    <div class="qr-illustration" aria-hidden="true">
      <svg width="56" height="56" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="4" y="4" width="26" height="26" rx="4" stroke="#111" stroke-width="2.5" fill="none"/>
        <rect x="10" y="10" width="14" height="14" rx="2" fill="#111"/>
        <rect x="42" y="4" width="26" height="26" rx="4" stroke="#111" stroke-width="2.5" fill="none"/>
        <rect x="48" y="10" width="14" height="14" rx="2" fill="#111"/>
        <rect x="4" y="42" width="26" height="26" rx="4" stroke="#111" stroke-width="2.5" fill="none"/>
        <rect x="10" y="48" width="14" height="14" rx="2" fill="#111"/>
        <rect x="42" y="42" width="6" height="6" rx="1.5" fill="#111"/>
        <rect x="52" y="42" width="6" height="6" rx="1.5" fill="#111"/>
        <rect x="62" y="42" width="6" height="6" rx="1.5" fill="#111"/>
        <rect x="42" y="52" width="6" height="6" rx="1.5" fill="#111"/>
        <rect x="52" y="52" width="6" height="6" rx="1.5" fill="#111"/>
        <rect x="62" y="62" width="6" height="6" rx="1.5" fill="#111"/>
        <rect x="42" y="62" width="6" height="6" rx="1.5" fill="#111"/>
        <rect x="62" y="52" width="6" height="6" rx="1.5" fill="#111"/>
        <rect x="52" y="62" width="6" height="6" rx="1.5" fill="#111"/>
        <line x1="0" y1="36" x2="72" y2="36" stroke="#111" stroke-width="1.5" stroke-dasharray="4 3" opacity="0.2"/>
        <line x1="4" y1="36" x2="68" y2="36" stroke="#111" stroke-width="2" opacity="0.65"/>
      </svg>
    </div>

    <!-- Logo -->
    <div class="login-logo">
      <img src="trkbl_final_logo.svg" alt="trkbl logo" />
    </div>

    <!-- Heading -->
    <h1 class="login-title">{{ isLoginMode ? 'Sign in' : 'Create account' }}</h1>
    <p class="login-subtitle">{{ isLoginMode ? 'Welcome back.' : 'Get started for free.' }}</p>

    <!-- Form -->
    <form [formGroup]="loginForm" (submit)="initiateLogin()" class="login-form">

      <!-- Email -->
      <div class="field-group">
        <label class="field-label" for="email">Email</label>
        <input
          id="email"
          type="email"
          formControlName="email"
          placeholder="you@example.com"
          class="field-input"
          [class.field-input--error]="loginForm.get('email')?.invalid && loginForm.get('email')?.touched"
        />
        <span class="field-error" *ngIf="loginForm.get('email')?.hasError('required') && loginForm.get('email')?.touched">Email is required.</span>
        <span class="field-error" *ngIf="loginForm.get('email')?.hasError('email') && loginForm.get('email')?.touched">Enter a valid email.</span>
      </div>

      <!-- Password -->
      <div class="field-group">
        <div class="field-label-row">
          <label class="field-label" for="password">Password</label>
          <a *ngIf="isLoginMode" routerLink="forgot" class="forgot-link">Forgot?</a>
        </div>
        <input
          id="password"
          type="password"
          formControlName="password"
          placeholder="••••••••"
          class="field-input"
          [class.field-input--error]="loginForm.get('password')?.invalid && loginForm.get('password')?.touched"
        />
        <span class="field-error" *ngIf="loginForm.get('password')?.hasError('required') && loginForm.get('password')?.touched">Password is required.</span>
        <span class="field-error" *ngIf="loginForm.get('password')?.hasError('minlength') && loginForm.get('password')?.touched">Must be at least 8 characters.</span>
      </div>

      <!-- Error Banner -->
      <div class="error-banner" *ngIf="showError">{{ errorMessage }}</div>

      <!-- Hidden Turnstile -->
      <div class="cf-turnstile hidden" data-sitekey="0x4AAAAAAA1MmgOZTMMmlB9r" data-theme="light"></div>

      <!-- Submit -->
      <button type="submit" class="submit-btn" [disabled]="loginForm.invalid || sendingData">
        <span *ngIf="!sendingData">{{ isLoginMode ? 'Sign in' : 'Create account' }}</span>
        <span *ngIf="sendingData" class="loader size-6 border-white border-b-transparent"></span>
      </button>

    </form>

    <!-- Toggle -->
    <p class="toggle-text">
      {{ isLoginMode ? "Don't have an account?" : "Already have an account?" }}
      <button type="button" (click)="toggleMode()" class="toggle-btn">
        {{ isLoginMode ? 'Sign up' : 'Log in' }}
      </button>
    </p>

  </div>

  <p class="login-footer">&copy; 2026 trkbl. All rights reserved.<br>Designed and developed at Xanadu Bengaluru.</p>

</div>